module.exports = __webpack_public_path__ + "img/partner16.b891a1c9.png";